var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldMoneyChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 4C4 4 2 5.5 2 9v3.56c0 .37.38.6.71.45.98-.45 2.11-.62 3.3-.41 2.63.47 4.56 2.91 4.49 5.58-.01.42-.07.83-.18 1.23-.08.31.17.6.49.6H17c3 0 5-1.5 5-5V9c0-3.5-2-5-5-5H7zm2.5 8a2.5 2.5 0 0 1 5 0 2.5 2.5 0 0 1-5 0zm9 2.75c-.41 0-.75-.34-.75-.75v-4c0-.41.34-.75.75-.75s.75.34.75.75v4c0 .41-.34.75-.75.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.89 15.49A3.96 3.96 0 0 0 1 18c0 2.21 1.8 4 4 4 1.74 0 3.23-1.11 3.77-2.67.15-.41.23-.86.23-1.33 0-2.2-1.79-4-4-4-1.25 0-2.38.59-3.11 1.49zm5.37 4.41-.72.71c-.09.1-.21.14-.34.14a.46.46 0 0 1-.35-.14.471.471 0 0 1-.08-.57H3.76c-.64 0-1.16-.52-1.16-1.17v-.1c0-.28.22-.49.49-.49s.49.21.49.49v.1c0 .11.08.2.19.2h2.01c-.1-.19-.08-.42.08-.58.19-.19.5-.19.68 0l.72.72c.04.04.08.1.11.16.04.11.04.25-.01.37-.02.06-.06.12-.1.16zm-.35-2.18c-.27 0-.49-.21-.49-.49v-.1c0-.11-.08-.2-.19-.2h-2a.483.483 0 0 1-.43.72c-.12 0-.25-.05-.34-.14l-.72-.72a.645.645 0 0 1-.11-.16.585.585 0 0 1 0-.37c.03-.05.06-.12.11-.16l.72-.71c.19-.2.5-.2.68 0 .16.15.18.39.08.57h2.01c.64 0 1.16.52 1.16 1.17v.1h.01c0 .28-.22.49-.49.49z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldMoneyChange);
export default __webpack_public_path__ + "static/media/vuesax-bold-money-change.955fc5930fc7474e6e1d0976e8ee2a1a.svg";
export { ForwardRef as ReactComponent };